/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../atoms/link/css/link';
import './link-list.scss';
import './modifier/quick.scss';
import './modifier/horizontal.scss';
import './modifier/inverse.scss';
import './modifier/caption.scss';
import './modifier/avatar-large.scss';
import './modifier/avatar-small.scss';
